<template>
  <router-view />
</template>
<script>
export default {
  name: "Purchase"
};
</script>
